/* eslint-disable no-unused-vars */
import { Cookies } from 'utils/libHelper';
import config from '../../config';
// import { AUTH_HANDLEAUTH_SUCCESS, /*AUTH_HANDLEAUTH_FAILED,*/ AUTH_LOGOUT } from 'redux/actions';
import {
	AUTH_HANDLEAUTH_SUCCESS,
	AUTH_HANDLEAUTH_FAILED,
	AUTH_LOGOUT,
	AUTH_LOGIN,
	FILEMANAGER_SEARCH_MEDIAFILE_COUNT,
	FILEMANAGER_SEARCH_MEDIAFILES_COUNT_SUCCESS,
	FILEMANAGER_SEARCH_MEDIAFILES_COUNT_FAIL,
	DOMAIN_SETTINGS,
	DOMAIN_SETTINGS_SUCCESS,
	DOMAIN_SETTINGS_FAIL,
	FETCH_USERPREFERENCES,
	FETCH_USERPREFERENCES_SUCCESS,
	FETCH_USERPREFERENCES_FAILED,
	FETCH_LIGHTBOXDETAILS,
	FETCH_LIGHTBOXDETAILS_SUCCESS,
	FETCH_LIGHTBOXDETAILS_FAILED,
} from 'redux/actions';

import { fetchUserData } from './usermanager';

let usermanagerAPIConf = config.usermanagerAPI;

const filemanagerAPIBaseUrl = config.filemanagerAPI.baseUrl;
const authHeaderKey = config.filemanagerAPI.authHeaderKey;

const usermanagerAPIBaseUrl = config.usermanagerAPI.baseUrl;
const authHeaderKeyUserManager = config.usermanagerAPI.authHeaderKey;
// const promises = [];

export const userLogout = (cb) => (dispatch, getState) => {
	// TODO: Need a proper logout handler when replacing the whole lasso app
	dispatch({
		type: AUTH_LOGOUT,
	});

	if (typeof cb === 'function') cb();
};

// // TODO: Need a proper logout handler when replacing the whole lasso app
// export const userLogin = (opts, cb) => (dispatch, getState) => {
// 	console.log('@@', opts);
// 	dispatch({
// 		type: AUTH_HANDLEAUTH_SUCCESS,
// 		result: { accessToken: opts.accessToken },
// 	});
// 	if (typeof cb === 'function') cb();
// };

export const userLoginAuth = (opts, cb) => (dispatch, getState) => {
	let reqUrl = `${usermanagerAPIConf.baseUrl}/login?${usermanagerAPIConf.apiKeyName}=${usermanagerAPIConf.apiKeyValue}`;
	let axiosConfig = {
		url: reqUrl,
		method: 'post',
		data: opts.reqData,
		// headers: reqHeader,
		timeout: 30000,
	};
	return dispatch({
		// types: AUTH_LOGIN,
		types: [AUTH_LOGIN, AUTH_HANDLEAUTH_SUCCESS, AUTH_HANDLEAUTH_FAILED],
		promise: (client) => {
			return client.request(axiosConfig);
		},
		afterSuccess: ({ dispatch, getState, result, error }) => {
			if (typeof cb === 'function') cb({ dispatch, getState, result, error });
			if (!error) {
				postAuthProcess(dispatch, getState);
			}
		},
	});
};

export const handleAuth = (opts, cb) => (dispatch, getState) => {
	let accessToken = Cookies.get(config.authCookieKey) || localStorage.getItem(config.authCookieKey);
	let data = {};
	if (accessToken) {
		data.accessToken = accessToken;
		dispatch({
			type: AUTH_HANDLEAUTH_SUCCESS,
			result: { data: data },
		});
		postAuthProcess(dispatch, getState);
	}
};

const postAuthProcess = async (dispatch, getState) => {
	const authState = getState().authentication;
	if (!authState.isLoggedIn()) return;
	Promise.allSettled([
		searchFileManagerMediafiles(dispatch, getState),
		getDomainSettings(dispatch, getState),
		fetchUserData()(dispatch, getState),
		fetchUserPreferences()(dispatch, getState),
	]).then((result) => console.debug(result));
};

const searchFileManagerMediafiles = async (dispatch, getState) => {
	var dateFrom = new Date(new Date());
	dateFrom.setUTCHours(0, 0, 0, 0); // START TIME of the day
	var dateTo = new Date(new Date());
	dateTo.setUTCHours(23, 59, 59, 999); // END time of the day
	let reqUrl = `${filemanagerAPIBaseUrl}/mediafiles`;
	const authState = getState().authentication;
	let reqHeader = {
		'Content-Type': 'application/json',
		[authHeaderKey]: authState.token,
	};
	let filters = {
		createdDatetimeFrom: dateFrom.toISOString(),
		createdDatetimeTo: dateTo.toISOString(),
		createdByUIDs: [getState().authentication.userId],
	};
	let axiosConfig = {
		url: reqUrl,
		method: 'post',
		headers: reqHeader,
		params: {
			domain: authState.domainName,
			uid: authState.userId,
			// ...(opts.queryParams || {}),
		},
		data: { filters: filters },
		timeout: 90000,
	};

	return new Promise((res, rej) => {
		dispatch({
			types: [
				FILEMANAGER_SEARCH_MEDIAFILE_COUNT,
				FILEMANAGER_SEARCH_MEDIAFILES_COUNT_SUCCESS,
				FILEMANAGER_SEARCH_MEDIAFILES_COUNT_FAIL,
			],
			promise: (client) => {
				return client.request(axiosConfig);
			},
			// afterSuccess: ({ dispatch, getState, result, error }) => {
			// 	if (error) return rej(error);
			// 	else {
			// 		res(result);
			// 	}
			// },
		});
	});
};

const getDomainSettings = async (dispatch, getState) => {
	let reduxState = getState();

	// let reqUrl = `${filemanagerAPIBaseUrl}/mediafiles`;
	let reqUrl = `${usermanagerAPIBaseUrl}/domains/${reduxState.authentication.domainName}/settings`;
	const authState = getState().authentication;
	let reqHeader = {
		'Content-Type': 'application/json',
		[authHeaderKey]: authState.token,
	};
	let axiosConfig = {
		url: reqUrl,
		method: 'get',
		headers: reqHeader,
		params: {
			domain: authState.domainName,
			uid: authState.userId,
			// ...(opts.queryParams || {}),
		},
		// data: { filters: filters },
		timeout: 90000,
	};

	return new Promise((res, rej) => {
		dispatch({
			types: [DOMAIN_SETTINGS, DOMAIN_SETTINGS_SUCCESS, DOMAIN_SETTINGS_FAIL],
			promise: (client) => {
				return client.request(axiosConfig);
			},
			afterSuccess: ({ dispatch, getState, result, error }) => {
				if (error) return rej(error);
				else {
					res(result);
				}
			},
		});
	});
};

const fetchUserPreferences = (opts = {}, cb) => (dispatch, getState) => {
	const { queryParams = {} } = opts;
	let reduxState = getState();
	let reqUrl = `${usermanagerAPIBaseUrl}/users/${reduxState.authentication.userId}/preferences`;
	let reqHeader = {
		'Content-Type': 'application/json',
		[authHeaderKey]: reduxState.authentication.token,
	};
	let axiosConfig = {
		url: reqUrl,
		method: 'get',
		params: {
			domain: queryParams.domain ? queryParams.domain : reduxState.authentication.domainName,
			...queryParams,
		},
		headers: reqHeader,
		timeout: 30000,
	};
	return new Promise((res, rej) => {
		dispatch({
			types: [FETCH_USERPREFERENCES, FETCH_USERPREFERENCES_SUCCESS, FETCH_USERPREFERENCES_FAILED],
			promise: (client) => {
				return client.request(axiosConfig);
			},
			afterSuccess: async ({ dispatch, getState, result, error }) => {
				if (error) {
					rej(error);
				} else {
					const userPrefsKey = result.data?.userPrefs?.lightbox;
					if (!userPrefsKey) {
						res(result);
					} else {
						try {
							const userPrefsDetail = await getUserPrefsDetail(
								userPrefsKey,
								queryParams.domain || reduxState.authentication.domainName,
								dispatch,
								getState
							);
							res({ ...result, userPrefsDetail }); // Combine results
						} catch (detailError) {
							console.error('Error fetching user prefs detail:', detailError);
							rej(detailError);
						}
					}
				}
			},
		});
	});
};

const getUserPrefsDetail = (lightboxKey, domain, dispatch, getState) => {
	let reqUrl = `${filemanagerAPIBaseUrl}/lightboxes/${lightboxKey}`;
	const authState = getState().authentication;

	let reqHeader = {
		'Content-Type': 'application/json',
		[authHeaderKey]: authState.token,
	};
	let axiosConfig = {
		url: reqUrl,
		method: 'get',
		headers: reqHeader,
		params: { domain }, // Use the domain parameter passed to the function
		timeout: 30000,
	};

	return new Promise((res, rej) => {
		dispatch({
			types: [FETCH_LIGHTBOXDETAILS, FETCH_LIGHTBOXDETAILS_SUCCESS, FETCH_LIGHTBOXDETAILS_FAILED],
			promise: (client) => client.request(axiosConfig), // Make sure this returns a valid promise
			afterSuccess: ({ result, error }) => {
				if (error) {
					rej(error);
				} else {
					res(result);
				}
			},
		});
	});
};
// export const handleAuth = _handleAuth;

// let logout = (cb) => (dispatch, getState) => {
// 	dispatch({
// 		type: AUTH_LOGOUT
// 	});
// 	if(typeof cb === 'function')
// 		cb();
// }
// export const AUTH_LOGOUT = 'AUTH_LOGOUT';
// export const authLogout = logout;
